class OpusRedirect extends HTMLElement {
  constructor () {
    super()

    const currentCurrency = this.dataset.cartCurrency
    const messageSeen = sessionStorage.getItem('opus-redirect-seen')

    if (currentCurrency === 'USD' && !messageSeen) {
      this.activateModal()

      const cancelButton = this.querySelector('[data-opus-modal-el="cancel"]')
      cancelButton.addEventListener('click', this.closeModal.bind(this))
    }
  }

  activateModal () {
    this.classList.remove('mod-OpusRedirect_Hidden')
  }

  closeModal () {
    this.classList.add('mod-OpusRedirect_Hidden')

    sessionStorage.setItem('opus-redirect-seen', true)

    const currentUrl = window.location.href
    let newUrl = ''

    if (currentUrl.includes('?')) {
      newUrl = `${currentUrl}&currency=GBP`
    } else {
      newUrl = `${currentUrl}?currency=GBP`
    }

    window.location.replace(newUrl)
  }
}

if (!customElements.get('opus-redirect')) {
  customElements.define('opus-redirect', OpusRedirect)
}
